<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction padding-bottom-five">
      <div class="container autoContent">
        <div class="row">
          <div class="col-xl-8 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block margin-xl-top-5">
              <h1 class="text-black fw-bold text-full-28 family-grand-stander margin-bottom-3 text-xs-size-20">
               Mobile Dog Grooming Services In Dubai – Treat Your Pet with Care
              </h1>
              <p class="text-black text-size-14 family-inter-light text-full-13 margin-bottom-3">
                Searching for the best dog groomer in Dubai at a reasonable price? At Dubai Pet Groomer, we offer mobile dog grooming services that treat your pet with extra care. We not only focus on the physical appearance and cleaning aspects but also create a positive impact on their overall mental and behavioral aura.
              </p>
              <p class="text-black text-size-14 family-inter-light text-full-13 margin-bottom-3">
                Being passionate animal lovers, we know that your dog is more than just a pet. They’re a valued member of your family. Our certified and experienced groomers provide professional, hassle-free grooming services at your doorstep, customized for all breeds and sizes.
              </p>
            </div>
          </div>
          <div class="col-xl-4 col-12 mt-3 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block 
              dog-about-image">
              <img class="w-100" v-lazy="require('@/assets/images/dog-grooming-dog-groomer-mobile-dog-grooming.png')" alt="dog grooming, dog groomer, mobile dog grooming">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-gallery gallery-section">
      <div class="container autoContent">
        <div class="row margin-top-4">
          <div class="col-12">
            <div class="w-100 d-inline-block text-center margin-top-2">
              <p class="mb-0 text-size-14 text-uppercase nav-color fw-bold inter-bold-family text-full-14">
                OUR Plans
              </p>
              <h2 class="half-black fw-bold text-full-24 family-grand-stander text-uppercase text-size-24 margin-bottom-2 text-xs-size-20">
                Mobile Dog Grooming Services We Offer
              </h2>
              <p class="margin-bottom-2 text-size-14 text-black inter-regular-family d-block w-85 m-auto w-xs-100 w-sm-100 w-md-100 w-ipad-100 text-full-13">
                Whether you're looking for basic dog grooming or a full pampering experience for your lovely dog, we are here to help you. We as a Mobile Dog Grooming Service provider, offer quality services with experienced staff that treat your pet with extra care. 
              </p>
            </div>
          </div>
        </div>
        <div class="row margin-top-4 margin-bottom-4">
      <div class="col-12">
        <div class="w-100 d-inline-block gallery-slider about-slider position-relative">
          <div class="carousel-container">
            <transition-group class="carousel" tag="div">
              <div v-for="(plan) in planDetailPrices" :key="plan.id" class="slide">
                <div class="card w-100 d-inline-block border-0 rounded-4">
                  <img class="slide-image w-100" v-lazy="$getImageUrl(plan.image)" :alt="plan.image">
                  <div class="card-body">
                    <h3 class="card-title text-size-14 inter-bold-family overflow-hidden margin-bottom-2 text-full-14">
                      {{ plan.name }}
                    </h3>
                    <p class="card-text text-black text-size-14 inter-regular-family overflow-hidden margin-bottom-2 text-full-13">
                      {{ plan.description }}
                    </p>
                    <a href="javascript:void(0)" class="nav-color rounded-5 text-uppercase text-size-13 d-inline-block medium-family border-blue me-xl-2 me-3 book-service-btn text-full-13"
                      @click="addToCart(plan)">
                      Book Service
                    </a>
                    <span class="text-size-16 nav-color fw-bold family-grand-stander d-inline-block mt-xl-0 mt-2 mt-lg-0 mt-md-0 text-full-16">
                      {{ plan.unit }} {{ plan.price }} 
                    </span>
                  </div>
                </div>
              </div>
            </transition-group>
            <div class="carousel-controls">
              <a href="javascript:void(0)" class="carousel-prev-btn position-absolute" @click="previous">
                <img class="position-absolute" src="@/assets/images/prev-left-icon.svg" alt="picture" />
              </a>
              <a href="javascript:void(0)" class="carousel-next-btn position-absolute" @click="next">
                <img class="position-absolute" src="@/assets/images/next-right-icon.svg" alt="picture" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
    
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row mt-xl-5 mt-4">
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a
                class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
                @click="toggleCollapse"
                >
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              How frequently do dogs need grooming?
              </span>
              </a>
              <div :class="['collapse', { show: isOpen }]" id="collapseExample">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    It varies depending on your dog's requirements. Dogs typically require grooming every 4-6 weeks; however, some may require more frequent sessions to be neat and cozy.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              What does a complete grooming session contain?
              </span>
              </a>
              <div class="collapse" id="collapseExample2">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    A thorough grooming service includes everything, depending on the package you choose, whether it's a basic grooming or full grooming service ensuring full hygiene of your pet.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample3" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              Will my dog become stressed because of grooming?
              </span>
              </a>
              <div class="collapse" id="collapseExample3">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Your dog's comfort is our first priority so we use gentle, pet-friendly methods to provide a peaceful and enjoyable time. Our groomers have been qualified to pamper dogs of all breeds with love and care.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample4" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              Do you use products suitable for sensitive skin?
              </span>
              </a>
              <div class="collapse" id="collapseExample4">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Absolutely! We utilize hypoallergenic products that are appropriate for all skin types. Please inform us beforehand if your dog has any known allergies.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample5" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              How much time does a grooming session require for the dog?
              </span>
              </a>
              <div class="collapse" id="collapseExample5">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    The length of time spent grooming a dog is governed by its demands, including size, coat condition, and services required. It typically takes between 1 and 3 hours.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample6" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              Can I stay with my dog during the grooming session?
              </span>
              </a>
              <div class="collapse" id="collapseExample6">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Yes, you can stay throughout the initial consultation. Some dogs may be more relaxed if their owners are not there, but we will do whatever makes you and your dog the most comfortable.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block">
              <h2 class="text-black fw-bold filson-black-family text-full-28 w-65 w-xs-100 w-sm-100 w-md-100 w-ipad-100 margin-bottom-2 text-xs-size-20">
                What Makes Us Unique?
              </h2>
              <p class="mb-0 text-size-14 text-black family-inter-light text-full-13">
                Dubai Pet Groomers is known to provide a comprehensive range of dog grooming services, according to every distinct breed and personal preference of you and your furry friend. We take pride in providing stress-free and enjoyable grooming services that go beyond aesthetics. We specialize in grooming dogs of all breeds and sizes. We also recognize that all dogs have distinct personalities; as a result, we exclusively offer personalized services to your dogs for the best results
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3 about-video-image">
              <!-- <img class="w-100" src="@/assets/images/about-video-image.png" alt="picture"> -->
              <img class="w-100" v-lazy="require('@/assets/images/puppy-grooming-dog-nail-trimming-dog-grooming-near-me.png')" alt="puppy grooming, dog nail trimming, dog grooming near me">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row margin-top-2 margin-bottom-2">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0">
              <li class="float-start margin-right-2">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                <i class="fa fa-home nav-color" aria-hidden="true"></i>
                Home /
                </a>
              </li>
              <li class="float-start">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                Services
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'dogGroomingBannerComponent',
    data() {
    return {
      isOpen: true,
      planDetailPrices: [], 
    };
  },
      mounted() {
      this.fetchServiceCategories();
  },
      computed: {
        iconClass() {
          return this.isOpen ? "fa fa-check-circle-o text-green" : "fa fa-check-circle-o nav-color";
        },
      },
      methods: {
      addToCart(service) {
        const cartData = localStorage.getItem('cart');
        let cart = cartData ? JSON.parse(cartData) : []; // Parse the cart or initialize as an empty array

        const serviceExists = cart.find((item) => item.id === service.id);

        if (serviceExists) {
          serviceExists.count++;
        } else {
          cart.push({ ...service, count: 1 });
        }
        localStorage.setItem('cart', JSON.stringify(cart));
        this.$router.push('/booking/');
      },
    async fetchServiceCategories() {
      try {
        const response = await this.$axios.post('/get-service-categories', {
          website_name: this.$websiteName,
          category_name: 'Dog Grooming',
        });
        if (response.data.status === "success") {
          this.planDetailPrices = response.data.planDetailPrices; // Assign the fetched data
        } else {
          console.error("Failed to fetch categories:", response.data);
        }
      } catch (error) {
        console.error('Error fetching categories:', error.response || error.message);
      }
    },
    previous() {
      const last = this.planDetailPrices.pop();
      this.planDetailPrices = [last].concat(this.planDetailPrices);
    },
    next() {
      const first = this.planDetailPrices.shift();
      this.planDetailPrices = this.planDetailPrices.concat(first);
    },
    toggleCollapse() {
      this.isOpen = !this.isOpen;
    },
  },
  }
</script>
<style scoped></style>